import { createSlice } from '@reduxjs/toolkit';

interface OfflineState {
  isOfflineMode: boolean;
}

const initialState: OfflineState = {
  isOfflineMode: false
};

const offlineSlice = createSlice({
  name: 'offline',
  initialState,
  reducers: {
    setOfflineMode: (state, action) => {
      state.isOfflineMode = action.payload;
    }
  }
});

export const { setOfflineMode } = offlineSlice.actions;
export default offlineSlice.reducer;
